<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row>
      <v-col cols="12">
        <header-big :title="$t('Titles.not_found')"></header-big>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text class="text-h5 font-weight-bold text-center">
            {{ $t("NotFound.text") }}
          </v-card-text>
          <br />
          <v-row justify="center">
            <v-img
              :src="require('../../assets/img/not_found.jpg')"
              max-height="1000"
              max-width="450"
            ></v-img>
          </v-row>
          <v-row justify="center">
            <a href="https://www.freepik.com/vectors/website"
              >Website vector created by stories - www.freepik.com</a
            >
          </v-row>
          <br />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/i18n";
import HeaderBig from "../../components/ui/text/HeaderBig";
import { log } from "@/helpers/logger";

export default {
  name: "MainPage",
  title: i18n.t("Titles.not_found"),
  components: {
    HeaderBig,
  },
  created: function () {
    log("NotFoundPage.index.created - not found page triggered");
  },
};
</script>